var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"loader-wrapper",class:_vm.isLocal ? 'local-wrapper': ''},[_c('Spinner',{attrs:{"loading":_vm.isLoading,"color":_vm.spinnerColor}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }